import { NavLink, Outlet } from "react-router";

import { useAdminStats } from "../../lib/queries";

export function AdminLayout() {
  const pending = useAdminStats().data?.users.pending_approval ?? 0;
  return (
    <div className="page admin">
      <div className="page-head">
        <div>
          <h1>Administration</h1>
        </div>
      </div>
      <nav className="admin-tabs" aria-label="Administration">
        <NavLink to="/admin" end>
          Statistiques
        </NavLink>
        <NavLink to="/admin/utilisateurs">
          Utilisateurs
          {pending > 0 && (
            <span className="admin-tabs__badge" aria-label={`${pending} en attente`}>
              {pending}
            </span>
          )}
        </NavLink>
        <NavLink to="/admin/donnees">Données</NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
